import { defineStore } from 'pinia'
import { login, getUserInfo } from '@/api/auth'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    token: localStorage.getItem('admin_token') || '',
    isLoading: false
  }),

  getters: {
    isLoggedIn: (state) => !!state.token,
    userInfo: (state) => state.user
  },

  actions: {
    // 登录
    async login(credentials) {
      this.isLoading = true
      try {
        const response = await login(credentials)
        console.log('登录响应:', response)

        let token, user

        if (response && (response.code === 200 || response.code === 0)) {
          token = response.data?.token
          user = response.data?.adminInfo || null
        }
        
        if (!token) {
          throw new Error('登录成功但未获取到令牌');
        }
        
        this.token = token;
        this.user = user || { username: 'admin' }; // 如果没有用户信息，提供默认值
        
        // 确保 token 被正确存储
        localStorage.setItem('admin_token', token);
        
        // 验证 token 是否正确存储
        const storedToken = localStorage.getItem('admin_token');
        if (!storedToken || storedToken !== token) {
          console.error('Token 存储失败:', { 
            expected: token, 
            actual: storedToken 
          });
          throw new Error('令牌存储失败');
        }
        
        // 打印存储的令牌，方便调试
        console.log('存储的令牌:', token);
        
        return { success: true };
      } catch (error) {
        console.error('登录错误:', error);
        return { 
          success: false, 
          message: error.response?.data?.message || error.message || '登录失败' 
        };
      } finally {
        this.isLoading = false;
      }
    },

    // 获取用户信息
    async getUserInfo() {
      if (!this.token) return
      
      try {
        const response = await getUserInfo()
        if (response && (response.code === 200 || response.code === 0)) {
          this.user = response.data
          return response.data
        }
        this.logout()
        throw new Error('获取管理员信息失败')
      } catch (error) {
        this.logout()
        throw error
      }
    },

    // 登出
    logout() {
      this.user = null
      this.token = ''
      localStorage.removeItem('admin_token')
    },

    // 更新用户信息
    updateUser(userData) {
      this.user = { ...this.user, ...userData }
    }
  }
})
